import { createListenerMiddleware } from '@reduxjs/toolkit';
import { NotificationTypeEnum } from 'Components/designSystem';
import i18n from 'i18next';
import { showToast, ToastOptions } from 'modules/ToastManager';

import { updateJobPreferencesThunk } from './jobPreferencesSlice';

const jobPreferencesMiddleware = createListenerMiddleware();

const SUCCESS_NOTIFICATION_DURATION = 5000;

jobPreferencesMiddleware.startListening({
    actionCreator: updateJobPreferencesThunk.fulfilled,
    effect: async (_, listenerAPI) => {
        const toast: ToastOptions = {
            id: 'updateJobPreferences',
            type: NotificationTypeEnum.Success,
            description: i18n.t('successToastText', { ns: 'jobPreferences' }),
            duration: SUCCESS_NOTIFICATION_DURATION
        };

        listenerAPI.dispatch(showToast({ toast }));
    }
});

export default jobPreferencesMiddleware;
